import { useQuery } from "@tanstack/react-query"
import { shopifyLineItemPropertyKeysQuery } from "modules/settings/lib/shopify/shopifyLineItemPropertyKeysQuery"

export const useShopifyLineItemPropertyKeysQuery = (enabled: boolean) =>
  useQuery({ ...shopifyLineItemPropertyKeysQuery(), enabled })
